module.exports = ['$rootScope', '$utils', '$q', '$translate', 'mailService', 'User', 'Promise', 'globalMailService', 'readService',
  function ($rootScope, $utils, $q, $translate, mailService, User, Promise, globalMailService, readService) {
    // 适用于新建写信
    function composeMail0() {
      const deferred = $q.defer()

      mailService.compose(null, null, 'continue').then(function (results) {
        deferred.resolve(_fetchComposeInfo({ id: results['var'] }))
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 用于获取代收代发邮箱号码
    function getPopwebEmail() {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'user:getPOPAccounts'
        }
      }).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 用于获取共享邮箱信息
    function getShareACLInfo() {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:listSharedAccessMbox',
          random: Math.random()
        },
        data: {},
        cache: false
      }).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 适用于存草稿，发信
    function composeMail1(id, attrs, action, verifyCode) {
      const deferred = $q.defer()
      const data = {
        id: id,
        attrs: attrs,
        returnInfo: false
      }
      verifyCode = verifyCode || null
      if (verifyCode) {
        data.verifyCode = verifyCode
      }
      mailService.compose(id, data, action, verifyCode).then(function (results) {
        deferred.resolve(results)
      }, function (results) {
        deferred.reject(results)
      })
      return deferred.promise
    }

    // 回复邮件
    function replyMail(id, toAll, mboxa) {
      const deferred = $q.defer()
      toAll = (typeof toAll === 'boolean') ? toAll : false
      readService.readMessage({id, mboxa}).then(function (mail) {
        // 构造回复内容
        const subject = 'Re:' + mail.subject
        const quoteHtmlStart = globalMailService.getQuoteHTMLStart('reply', mail)

        mailService.replyMessage(id, toAll, subject, quoteHtmlStart, '', mboxa).then(function (result) {
          deferred.resolve(_fetchComposeInfo(result, true))
        }, function (error) {
          deferred.reject(error)
        })
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 转发邮件
    function forwardMail(id, mboxa) {
      const deferred = $q.defer()
      readService.readMessage({id, mboxa}).then(function (mail) {
        // 构造转发内容
        const subject = 'Fw:' + mail.subject
        const quoteHtmlStart = globalMailService.getQuoteHTMLStart('forward', mail)
        mailService.forwardMessage(id, subject, quoteHtmlStart, '', mboxa).then(function (result) {
          deferred.resolve(_fetchComposeInfo(result, true))
        }, function (error) {
          deferred.reject(error)
        })
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }
    // 再次编辑
    function sendAgain(id, mboxa) {
      const deferred = $q.defer()
      mailService.getAllMailMessage(id, mboxa).then(function (mailInfo) {
        // 构造转发内容
        deferred.resolve(_fetchComposeInfo(mailInfo, true, false, true))
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    function getComposeInfo(composeId) {
      const deferred = $q.defer()
      mailService.getComposeInfo({ id: composeId }).then(function (mailInfo) {
        deferred.resolve(_fetchComposeInfo(mailInfo, false))
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 继续写草稿
    function restoreMail(id, mboxa) {
      const deferred = $q.defer()
      mailService.restoreDraft(id, mboxa).then(function (result) {
        const mailContent = result.content
        let starStr, starIndex, splitStr, splitIndex, endIndex
        if (mailContent) {
          starStr = '<pre>'
          starIndex = mailContent.indexOf(starStr)
          splitStr = '</pre><blockquote name="hxphone">'
          splitIndex = mailContent.indexOf(splitStr)
          endIndex = mailContent.lastIndexOf('</blockquote>')

          //  处理从hxphone模板回复邮件，保存草稿;区分邮件原文和回复时编辑邮件保存的草稿
          //  <pre>编辑的内容</pre><blockquote name="hxphone">邮件原文</blockquote>
          if (splitIndex != -1) {
            result.content = mailContent.substring(starIndex + starStr.length, splitIndex)
            result.quoteContent = mailContent.substring(splitIndex + splitStr.length, endIndex)
          }
        }
        deferred.resolve(_fetchComposeInfo(result, true))
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // private function
    // 根据ajax返回结果，构造页面初始化时，scope所需的邮件对象
    function _fetchComposeInfo(result, bForward, isPlainText) {
      const mail = {}
      const attachments = result['attachments']

      bForward = bForward || false
      isPlainText = isPlainText || false

      mail.id = result['id']
      mail.sender = result.account
      mail.to = constructRcpts(result['to'] || [])
      mail.cc = constructRcpts(result['cc'] || [])
      mail.bcc = constructRcpts(result['bcc'] || [])
      mail.subject = result['subject'] || ''
      mail.content = result['content'] || ''
      // 若草稿为html格式，则去掉html标记以作纯文本编辑，并将转义字符重新decode
      // if (!!result["isHtml"]) {
      //    mail.content = $utils.$html.decode($utils.$html.delHtmlTag(mail.content));
      // }
      mail.quoteContent = ''
      mail.attachments = []
      if (result.quoteContent) {
        mail.quoteContent = result.quoteContent
      }

      if (bForward) {
        mail.content = ''
        mail.quoteContent = isPlainText ? '<pre>' + $utils.$html.encode(result['content']) + '</pre>' : result['content']
      }

      if (attachments) {
        for (let i = 0; i < attachments.length; i++) {
          const attach = attachments[i]
          if (!attach.inlined) { // 内嵌图片不在附件中显示
            mail.attachments.push({
              'id': attach['id'],
              'name': attach['name'],
              'type': attach['type'],
              'contentType': attach['contentType'],
              'size': attach['size'],
              '_mid': attach['_mid'] || '',
              'deleted': false,
              // 此属性仅用于此处显示的附件名称，与服务器无关
              'showName': attach['name'] || $translate.instant('ATTACH.UNKNOWN_FILE')
            })
          }
        }
      }
      return mail
    }

    function constructRcpts(rcptsArr) {
      const rcptsObjsArr = []
      for (let i = 0; i < rcptsArr.length; i++) {
        rcptsObjsArr.push({
          email: $utils.$email.parse(rcptsArr[i]).addr,
          address: rcptsArr[i],
          selected: false,
          valid: $utils.$email.test(rcptsArr[i])
        })
      }
      return rcptsObjsArr
    }

    function getAttrs() {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'user:getAttrs'
        },
        data: {
          attrIds: [
            'email',
            'primary_email',
            'pref_quota',
            'true_name',
            'nick_name'
          ]
        },
        cache: true

      }).then(function (data) {
        if (data.code == 'S_OK') {
          deferred.resolve(data['var'])
        }
      })
      return deferred.promise
    }

    // 获取所有别名地址
    function getAliasWithSeed() {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'user:getAliasWithSeed'
        },
        data: {},
        cache: true
      }).then(function (data) {
        const aVar = data ? data['var'] : []
        if (data.code == 'S_OK') {
          const aliases = (aVar[1] && aVar[1]['aliases']) ? aVar[1]['aliases'] : []
          deferred.resolve(aliases)
        } else {
          deferred.reject()
        }
      }, function (data) {
        deferred.reject(data)
      })
      return deferred.promise
    }

    function clearAccountCache() {
      getAccounts.cache = []
    }

    // 获取用户所有可发信账户 构造含name的邮件地址数组 abc@abc.com，并缓存构造结果
    getAccounts.cache = []
    function getAccounts() {
      const deferred = $q.defer()
      if ($rootScope.settings.wechatMiniProgram) {
        getAttrs().then(function (userAttrs) {
          getAliasWithSeed().then(function (aliases) {
            _getUserAlias(userAttrs, aliases)
          }, function () {
            _getUserAlias(userAttrs, [])
          })
        })
        return deferred.promise
      }
      clearAccountCache()
      if (getAccounts.cache.length) {
        deferred.resolve(getAccounts.cache)
      } else {
        const userConfig = User.getCurrentUser().config
        if (userConfig && userConfig['primary_email']) {
          getAliasWithSeed().then(function (aliases) {
            _getUserAlias(userConfig, aliases)
          }, function () {
            _getUserAlias(userConfig, [])
          })
        } else {
          getAttrs().then(function (userAttrs) {
            getAliasWithSeed().then(function (aliases) {
              _getUserAlias(userAttrs, aliases)
            }, function () {
              _getUserAlias(userAttrs, [])
            })
          })
        }
      }

      function _getUserAlias(userAttrs, aliases) {
        const accounts = _formatAccounts(userAttrs, aliases)
        getPopwebEmail().then(function (result) {
          const popEmails = result['var'] || []
          for (let i = 0; i < popEmails.length; i++) {
            if (popEmails[i] && popEmails[i].delegatedSend) {
              const accountName = popEmails[i].username
              accounts.push(accountName)
            }
          }
          _getShareACLInfo()
        }, function () {
          _getShareACLInfo()
        })

        function _getShareACLInfo() {
          getShareACLInfo().then(function (result) {
            const aclInfo = result['var'] || []
            aclInfo.forEach(acc => {
              if (acc && acc.send) {
                const label = acc.rw ? `[${$translate.instant('SETTING.SHARED_MAILBOX.AGENT')}]` : `[${$translate.instant('SETTING.SHARED_MAILBOX.DELEGATE')}]`
                const accountName = label.concat(acc.email)
                accounts.push(accountName)
              }
            })
            _successCallback(accounts)
          }, function () {
            _successCallback(accounts)
          })
        }

        function _successCallback(accounts) {
          getAccounts.cache = accounts
          deferred.resolve(getAccounts.cache)
        }
      }
      return deferred.promise
    }

    // 组装主账号
    function _formatAccounts(userAttrs, aliases) {
      const accounts = []
      let bPrimaryAlias = false // 判断当前登录账号是否主别名
      let selectedAliasIdx = -1
      const currentAddr = userAttrs['email']
      let mainAccount = userAttrs['primary_email'] // 主账号
      const name = userAttrs['true_name'] || userAttrs['nick_name'] || ''

      for (let i = 0; i < aliases.length; i++) {
        let uid = aliases[i]['id']
        if (currentAddr == uid) {
          selectedAliasIdx = i
          if (currentAddr == userAttrs['primary_email']) {
            bPrimaryAlias = true
          }
        }
        if (name) {
          uid = '"' + name + '"' + ' <' + uid + '>'
        }
        accounts.push(uid)
      }

      if (selectedAliasIdx == -1) {
        // 如果当前登录账号是主账号
        let mainAccountStr = mainAccount
        if (name) {
          mainAccountStr = '"' + name + '"' + ' <' + mainAccount + '>'
        }
        accounts.unshift(mainAccountStr)
        // 如果当前登录账户跟主账号不一致
        // 并且这个账户并没有出现在 alias 里面
        // 同样需要将这个 Email 进入队列，并放在前面
        if (currentAddr !== mainAccount) {
          let currentAddrStr = currentAddr
          if (name) {
            currentAddrStr = '"' + name + '"' + ' <' + currentAddr + '>'
          }
          accounts.unshift(currentAddrStr)
        }
      } else {
        // 否则则命中了alias，将该alias放到第一个，作为选中状态
        const selectedAlias = accounts.splice(selectedAliasIdx, 1)[0]
        accounts.unshift(selectedAlias)
        if (!bPrimaryAlias) {
          if (name) {
            mainAccount = '"' + name + '"' + ' <' + mainAccount + '>'
          }
          accounts.push(mainAccount)
        }
      }
      return accounts
    }

    function prepareUpload(file, composeId) {
      const deferred = $q.defer()
      User.getCurrentUser().wmsvrClient.simpleCall({
        query: {
          func: 'upload:prepare',
          sid: User.getCurrentUser().sid
        },
        data: {
          inlined: false,
          size: file.size,
          fileName: file.name,
          attachmentId: -1,
          composeId: composeId
        }
      }).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error.data)
      })
      return deferred.promise
    }

    function directorUpload(composeId, attachmentId, file) {
      return globalMailService.uploadDirectData({
        composeId,
        attachmentId,
        blob: file.blob,
        offset: '0'
      })
    }

    function deleteTasks(composeId, items) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'upload:deleteTasks'
        },
        data: {
          composeId: composeId,
          items: items
        }
      }).then(function (data) {
        deferred.resolve(data['var'] || {})
      })
      return deferred.promise
    }
    function getFilesInfo(ids) {
      const deferred = $q.defer()
      const params = {
        ids: ids
      }
      Promise.wmCall('nf:getFileInfos', params).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    return {
      sendAgain: sendAgain,
      prepareUpload: prepareUpload,
      directorUpload: directorUpload,
      composeMail0: composeMail0,
      composeMail1: composeMail1,
      getComposeInfo: getComposeInfo,
      replyMail: replyMail,
      forwardMail: forwardMail,
      restoreMail: restoreMail,
      constructRcpts: constructRcpts,
      getAccounts: getAccounts,
      getAttrs: getAttrs,
      deleteTasks: deleteTasks,
      getPopwebEmail: getPopwebEmail,
      getShareACLInfo: getShareACLInfo,
      clearAccountCache: clearAccountCache,
      getFilesInfo: getFilesInfo,
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/compose/composeService.js